module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I bleed wine and gold, and Cleveland is my home! The city is flourishing now and ready to accept a winner. I’m glad a book is being written so more people can hear about the team’s rich history. We have come so close many times, and I believe that one day we can get over the hump!")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("—Austin Carr")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7d3b740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/for3.vue
// module id = 78
// module chunks = 0